import { Component, OnInit } from '@angular/core';
import { V1ContractService } from 'src/app/services/v1-contract.service';
import { AccountService } from 'src/app/services/account.service';
import { MigrationContractService } from 'src/app/services/migration-contract.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { switchNetwork, waitForTransaction, watchNetwork, writeContract } from '@wagmi/core'
import { V2ContractService } from 'src/app/services/v2-contract.service';

const abi = require('src/contracts/abi-dev/pdogv1.json');
const migrationAbi = require('src/contracts/abi-dev/migrator.json');

@Component({
  selector: 'app-migration',
  templateUrl: './migration.component.html',
  styleUrls: ['./migration.component.css']
})
export class MigrationComponent implements OnInit {

  migrationTransactions: any = [];
  successMessage: any = '';
  transactionHash: any = "";
  ethereum: any;
  account: any = {};
  v1Balance: number = 0;
  migrationAmount: number = 0;
  isApproved: boolean = false;
  isResponsive: boolean = false;
  isLoading: boolean = false;
  isEthereumNetwork: boolean = true;
  decimals: any
  symbol: any[];
  v2symbol;
  V1_CONTRACT_ADDRESS = '';
  V2_CONTRACT_ADDRESS = '';

  constructor(
    private v1ContractService: V1ContractService,
    private v2ContractService: V2ContractService,
    private accountService: AccountService,
    private migrationContract: MigrationContractService,
    private toastr: ToastrService,
    private commonService: CommonService,
  ) { }

  async ngOnInit() {
    this.v1ContractService.getContractAddress().then((response:any) => {
      this.V1_CONTRACT_ADDRESS = response;
    })
    this.v2ContractService.getContractAddress().then((response:any) => {
      this.V2_CONTRACT_ADDRESS = response;
    })
    const unwatch = watchNetwork((network) => {
    
      if (network?.chain?.unsupported) {
        this.isEthereumNetwork=false;
        this.getBalance();
        this.migrationTransactions = [];
      }
    })


    // Listening to account change
    this.accountService.accountObserve.subscribe(async (data) => {

      this.account = data;
      this.isEthereumNetwork = await this.commonService.isEthereumSupportedNetwork(this.account.chainId);
      (this.account?.address !== '' && this.isEthereumNetwork) ? this.getBalance() : this.v1Balance = 0;
      this.migrationTransactions = [];
    });

    if (this.isEthereumNetwork) {
      setInterval(() => {
        (this.account?.address !== '') ? this.getBalance() : this.v1Balance = 0;
      }, 1000)
    }
  }

  async getBalance() {
    if (this.isEthereumNetwork) {
      this.decimals = await this.v1ContractService.getDecimals(this.V1_CONTRACT_ADDRESS);
      let balance = await this.v1ContractService.getBalance(this.account.address,this.V1_CONTRACT_ADDRESS);
      this.symbol = await this.v1ContractService.getSymbol(this.V1_CONTRACT_ADDRESS);
      this.v2symbol = await this.v2ContractService.getSymbol(this.V2_CONTRACT_ADDRESS);
      this.v1Balance = Number(balance) / 10 ** this.decimals;
    }
  }

  setMax(value) {
    this.migrationAmount = parseFloat(value);
    (<HTMLInputElement>document.getElementById("floatingInput")).value = parseFloat(value).toString();
  }

  async changeMigrationAmount(event) {
    this.migrationAmount = event.target.value;
    let allowance: any = await this.v1ContractService.getAllowance(this.account.address, environment.MIGRATOR_ADDRESS, this.V1_CONTRACT_ADDRESS);
    if (allowance) {
      allowance = Number(allowance) / (10 ** this.decimals);
      if (allowance >= this.migrationAmount) {
        this.isApproved = true;
      } else {
        this.isApproved = false;
      }
    } else {
      this.isApproved = false;
    }
  }

  changeNetwork(){
    switchNetwork({
      chainId: environment.SUPPORTED_NETWORK,
    })
  }

  async approve() {
   
    this.isResponsive = true;
    let approveAddress = await this.migrationContract.getAddress();
    try {
      const { hash } = await writeContract({
        address: environment.V1_CONTRACT_ADDRESS,
        abi: abi,
        functionName: 'approve',
        args: [approveAddress, (this.migrationAmount * (10 ** this.decimals))],
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        })
          .then((receipt) => {
            this.isResponsive = false;
            this.toastr.success('Approved successfully');
            this.isApproved = true;

          })
          .catch((error) => {
            this.isResponsive = false;
            if (error.code == 4001) {
              this.toastr.error('User rejected');
            } else {
              error = JSON.stringify(error, null, 2);
              error = JSON.parse(error);
              this.toastr.error(error.shortMessage);
            }
          })
      }
    } catch (error: any) {
      this.isResponsive = false;
      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }
    }
  }

  async migrate() {
    
    this.isLoading = true;
    try {
      const { hash } = await writeContract({
        address: environment.MIGRATOR_ADDRESS,
        abi: migrationAbi,
        functionName: 'migrate',
        args: [this.account.address, (this.migrationAmount * (10 ** this.decimals))],
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        })
          .then((receipt) => {
            this.isLoading = false;
            this.toastr.success('Migrated successfully');
            this.successMessage = "Swap " + this.migrationAmount + " " + this.symbol + " for " + this.migrationAmount + " " + this.v2symbol
            this.transactionHash = receipt.transactionHash;
            const network = (this.isEthereumNetwork) ? 'eth' : 'bsc';
            this.migrationTransactions.push({ network: network, transactionHash: this.transactionHash, successMessage: this.successMessage });
            this.migrationAmount = 0;
            this.isApproved = false

          })
          .catch((error) => {
            this.isLoading = false;
            if (error.code == 4001) {
              this.toastr.error('User rejected');
            } else {
              error = JSON.stringify(error, null, 2);
              error = JSON.parse(error);
              this.toastr.error(error.shortMessage);
            }
          })
      }
    } catch (error: any) {
      this.isLoading = false;
      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }
    }
  }

  /**
   * Connects wallet
   */
  public connectWallet() {
    const data = {
      status: true,
    };
    this.accountService.openWallet(data);
  }

}
